// config.js
const apiUrl = 'https://kurti.onrender.com'; // Replace with your actual API base URL
export default apiUrl;
   
